// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"163":"aefdb5a6","369":"adcc51d9","705":"f6199c60","955":"1fc52bf8"}[chunkId] + ".chunk.css";
};